/** Matches a variant title delimiter: " / ", "/", " /", or "/ " */
export const VARIANT_TITLE_DELIMITER = /\s*\/\s*/u

export const INVENTORY_STATUS = {
  IN_STOCK: 'IN_STOCK',
  OUT_OF_STOCK: 'OUT_OF_STOCK',
  PARTIAL_OUT_OF_STOCK: 'PARTIAL_OUT_OF_STOCK',
}
